import React, { useEffect, useState } from "react";
import NavbarLeft from "./../Components/NavbarLeft";
import { Link } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { optimizationRun, resetOptimisationStatus } from "../../redux/actions/optimizationActions";
import firebase, { auth } from "../../firebase/config";
import { ToastWarn } from "../../commonComponents/ToastHelper";

const ReduceLoadingScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  // const auth = useSelector((state) => state.firebase.auth);
  const optimization_run_status = useSelector((state) => state.optimization.optimization_run_status, shallowEqual);
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)

  const dispatch = useDispatch();
  const optimizationRun_rd = (item) => dispatch(optimizationRun(item));
  const resetOptimisationStatus_rd = () => dispatch(resetOptimisationStatus());

  useEffect(() => {
    resetOptimisationStatus_rd();
    optimizationRun_rd({
      ANALYSIS_INFO: {
        ANALYSIS_ID: analysis_id,
        TENANT_ID: auth.currentUser.tenantId.toLowerCase(),
        USER_ID: auth.currentUser.uid,
      },
      PARAMS: location.state.cibles,
    });

    setTimeout(() => {
      setMessage("Définition du modèle...");
    }, 1000);

    setTimeout(() => {
      setMessage("Définition des variables...");
    }, 1800);

    setTimeout(() => {
      setMessage("Définition des contraintes...");
    }, 3000);

    setTimeout(() => {
      setMessage("Définition de la fonction objectives...");
    }, 4000);

    setTimeout(() => {
      setMessage("Résolution du problème...");
    }, 5000);

    setTimeout(() => {
      setMessage("Écriture des résutlats...");
    }, 6500);
  }, []);

  useEffect(() => {
    console.log("NAVIGOTO", optimization_run_status);
    if (optimization_run_status === "success") {
      console.log("---GOING");
      setTimeout(() => {
        navigate("/ReduceAnalysis");
      }, 9000);
    } else if (optimization_run_status === "no_solution") {
      setTimeout(() => {
        navigate("/ReduceParametersChoice");
        ToastWarn("Pas de solution trouvée. Veuillez réessayer une fois que de nouvelles données seront disponibles.");
      }, 9000);
    }
  }, [optimization_run_status]);

  const [message, setMessage] = useState("Lancement de l'optimisation...");

  return (
    <div className="h-full w-full">
      <NavbarLeft currentPage={3} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          {/* <Link to="/ReduceParametersChoice"> */}
          <button
            onClick={() => {
              resetOptimisationStatus_rd();
              navigate("/ReduceParametersChoice");
            }}
          >
            <BackArrow />
          </button>
          {/* </Link> */}
          <p className="font-Poppins-SemiBold text-lg relative p-10"> {"Réduire - Scénario analysé - " + analysis_data.lca.lca_steps[0].ciqual_name.fr}</p>
        </div>
      </div>
      <div className="relative w-full h-full flex justify-center items-center">
        <div className="">
          <p className="text-center text-5xl font-Poppins-SemiBold">Optimisation en cours</p>
          <p className="text-center mt-[40px] text-xs font-Poppins-Light">{message}</p>
          <div className="w-full flex justify-center my-[20px]">
            {/* <Link to={"/ReduceScenarios"} className="flex justify-between w-[300px]"> */}
            <div className="flex justify-between w-[300px]">
              <div className="gg-white shadow-xl h-[75px] w-[75px] rounded-full"></div>
              <div className="gg-white shadow-xl h-[75px] w-[75px] rounded-full"></div>
              <div className="gg-white shadow-xl h-[75px] w-[75px] rounded-full"></div>
            </div>
          </div>

          {/* <button onClick={() => {
              resetOptimisationStatus_rd();
              navigate("/ReduceParametersChoice");
            }}utton
            className="text-center"
           
          > */}
          <p
            onClick={() => {
              resetOptimisationStatus_rd();
              navigate("/ReduceParametersChoice");
            }}
            className="text-center text-xs font-Poppins-Light mt-[40px] cursor-pointer"
          >
            Annuler
          </p>
          {/* </button> */}
        </div>
      </div>
    </div>
  );
};

export default ReduceLoadingScreen;
